import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5c6a2940"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c6a2940')) {
      api.createRecord('5c6a2940', component.options)
    } else {
      api.reload('5c6a2940', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5c6a2940", function () {
      api.rerender('5c6a2940', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/message-forwarding/index.vue"
export default component.exports